<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col md="6">
        <b-card>
          <div slot="header">
            <strong>Add New Inventory Item</strong>
          </div>
          <b-form>
            <b-form-group
              label="Date" label-for="date"
              description="Date of transaction"
              :label-cols="3"
            >
              <b-form-input type="date" id="date"></b-form-input>
            </b-form-group>
<!--            <b-form-group-->
<!--              description="FNSID on device."-->
<!--              label="Enter FNSID"-->
<!--              label-for="basicName"-->
<!--              :label-cols="3"-->
<!--            >-->
<!--              <b-form-input id="basicName" type="text" autocomplete="name"></b-form-input>-->
<!--            </b-form-group>-->
            <b-form-group
            description="This is device manufacturer"
            label="Manufacturer"
            label-for="basicText"
            :label-cols="3"
          >
            <b-form-input id="basicText" type="text" placeholder="Text"></b-form-input>
          </b-form-group>
            <b-form-group
              description="This is device model"
              label="Model"
              label-for="basicText"
              :label-cols="3"
            >
              <b-form-input id="basicText" type="text" placeholder="Text"></b-form-input>
            </b-form-group>
            <b-form-group
              description="This is device serial number"
              label="Serial No."
              label-for="basicText"
              :label-cols="3"
            >
              <b-form-input id="basicText" type="text" placeholder="Text"></b-form-input>
            </b-form-group>
            <b-form-group
              label="Description"
              label-for="basicTextarea"
              :label-cols="3"
            >
              <b-form-textarea id="basicTextarea" :rows="9" placeholder="Content.."></b-form-textarea>
            </b-form-group>
            <b-form-group
              label="From Location"
              label-for="basicSelect"
              :label-cols="3"
            >
              <b-form-select id="basicSelect"
                             :plain="true"
                             :options="locations"
                             value="Please select">
              </b-form-select>
            </b-form-group>
            <b-form-group
              label="To Location"
              label-for="basicSelectLg"
              :label-cols="3"
            >
              <b-form-select id="basicSelectLg"
                             size="lg"
                             :plain="true"
                             :options="locations"
                             value="Please select">
              </b-form-select>
            </b-form-group>
            <b-form-group
              label="Features"
              label-for="basicCustomCheckboxes"
              :label-cols="3"
            >
              <b-form-checkbox-group stacked id="basicCustomCheckboxes">
                <div class="custom-control custom-checkbox">
                  <input type="checkbox" class="custom-control-input" id="customChk1" value="1" checked>
                  <label class="custom-control-label" for="customChk1">Warranty</label>
                </div>
                <div class="custom-control custom-checkbox">
                  <input type="checkbox" class="custom-control-input" id="customChk2" value="2">
                  <label class="custom-control-label" for="customChk2">B.E.R</label>
                </div>
                <div class="custom-control custom-checkbox">
                  <input type="checkbox" class="custom-control-input" id="customChk3" value="3">
                  <label class="custom-control-label" for="customChk3">OEM Repair</label>
                </div>
              </b-form-checkbox-group>
            </b-form-group>

            <b-form-group
              label="Add attachment"
              label-for="fileInput"
              :label-cols="3"
            >
              <b-form-file id="fileInput" :plain="true"></b-form-file>
            </b-form-group>
            <div slot="footer">
              <b-button type="submit" size="sm" variant="primary"><i class="fa fa-dot-circle-o"></i> Save item</b-button>
            </div>
          </b-form>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
  import router from '../../router'

  export default {
    components: {
      router
    },
    name: 'forms',
    data () {
      return {
        locations: [],
        selected: [], // Must be an array reference!
        show: true
      }
    },
    methods: {
      click () {
        router.push('/base/inventory')
      }
    },
    mounted () {
    }
  }
</script>

<style scoped>
  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.5s;
  }
  .fade-enter,
  .fade-leave-to {
    opacity: 0;
  }
</style>
